var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-item-doodle-text",class:_vm.animationClassName,style:(_vm.rectStyle)},[_c('span',{staticClass:"doodle",style:(_vm.textStyle),domProps:{"innerHTML":_vm._s(_vm.htmlValue)}})])}
var staticRenderFns = []

export { render, staticRenderFns }